import React from "react";
import { Link } from "react-router-dom";
import { AccountType, PageHeader } from "component-library";

import Breakdown from "shared/components/Breakdown/Breakdown";

import applicationMap from "services/applicationMap";

import "./FollowUpView.scss";

export interface IFollowUpViewTexts {
  title: string;
  sentBy: string;
  breakdownInfo: string;
  breakdownTitle: string;
}

export interface IFollowUpViewProps {
  message: string;
  userType: AccountType;
  texts: IFollowUpViewTexts;
  breakdownId: string;
  actionList?: JSX.Element;
}

export class FollowUpView extends React.PureComponent<IFollowUpViewProps> {
  public render() {
    const { message, userType, texts, breakdownId, actionList } = this.props;

    return (
      <article className="c-follow-up-view">
        <PageHeader
          pageTitle={this.renderPageTitle()}
          actionSection={actionList}
        />
        <Breakdown.Content limitWidth={true}>
          <Breakdown.Message keepFormatting={true}>{message}</Breakdown.Message>
          {userType === AccountType.Agent && (
            <div className="c-follow-up-view__breakdown-info">
              {texts.breakdownInfo}
              <Link
                to={applicationMap.links.jobBreakdown(breakdownId)}
                className="g-alternative-link"
              >
                {texts.breakdownTitle}
              </Link>
            </div>
          )}
        </Breakdown.Content>
      </article>
    );
  }

  public renderPageTitle() {
    const { texts } = this.props;

    return (
      <Breakdown.Title
        title={texts.title}
        sentBy={texts.sentBy}
        closingDate=""
        exclusive={false}
        exclusiveText=""
        exclusiveTitle=""
      />
    );
  }
}

export default FollowUpView;
